import { canUseDOM } from 'exenv';

export default function knotch() {
  if (canUseDOM) {
    return `
    <script type="text/javascript" src="https://www.knotch-cdn.com/unit/latest/knotch.min.js" async></script>
  `;
  }
  return '';
}
